module.exports = __webpack_public_path__ + "img/ergoregion-4.6d1c2c93.png";